declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const META_PIXEL_ID = '2548080012242528';

/** Injects the standard Meta Pixel snippet into <head> and fires PageView once. */
export function initMetaPixel() {
  if (typeof document === 'undefined' || document.getElementById('meta-pixel')) return;

  const script = document.createElement('script');
  script.id = 'meta-pixel';
  script.text = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${META_PIXEL_ID}');fbq('track','PageView');`;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`;
  document.head.appendChild(noscript);
}

/** Fires the Meta "Lead" standard event. */
export function trackLead(params?: Record<string, string>) {
  window.fbq?.('track', 'Lead', params);
}
